import { z } from 'zod'
import { ensureOutlookPrivacyMode, isOutlookPrivacyMode } from '@/analytics/privacy/outlook-continuation-privacy'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { kMatterArtifactVersionsBasePath } from '@/matter-artifacts/constants'
import { readResponseJson } from '@/util/api/response-body'
import { ApiError } from '@/util/errors/api-error'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'

const privacySchema = z.object({ requires_outlook_privacy: z.boolean() }).strict()

/** Classify before fetching metadata, signed content URLs, or exports observable by web vendors. */
export async function ensureMatterArtifactPrivacy(versionId: string, token: string): Promise<void> {
  // The add-in retains its separate, after-Copy analytics boundary.
  if (!window.__paxtonWebDocument || isOutlookPrivacyMode()) return
  const response = await fetch(`${kPaxtonAppApiRESTBaseUrl()}${kMatterArtifactVersionsBasePath}/${encodeURIComponent(versionId)}/privacy`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) throw new ApiError(response.status, 'Could not check draft privacy')
  const { data, parseError } = await readResponseJson(response)
  const parsed = privacySchema.safeParse(data)
  if (parseError || !parsed.success) throw new ApiResponsePayloadError(response.status, 'Invalid draft privacy response')
  if (parsed.data.requires_outlook_privacy && !ensureOutlookPrivacyMode('outlook')) {
    throw new DOMException('Opening protected draft', 'AbortError')
  }
}
